import React from 'react';
import { applyLink } from 'flow/utils/message-utils';

interface Props {
    label: string;
    children: string;
}
const ContactField = ({ label, children }: Props) => (
    <div className="mx-4 flex grow items-center justify-between rounded-sm p-2 md:flex-row">
        <div className="whitespace-nowrap text-gray-800">{label}</div>
        <div className="text-end text-sm text-gray-500">
            {applyLink(children)}
        </div>
    </div>
);

export default ContactField;
